import React, { useEffect, useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { Edit, getExpenseBilingWorksheetForDatatableAsync,checkedBilledState,unCheckedBilledState,updateSorting } from './expenseBillingSlice';
import CustomPagination from "../../../common/Pagination";
import OffCanvas from '../../../common/OffCanvas';
import { Link } from 'react-router-dom';
import moment from 'moment';
/* import { TimeEntryArchiveForm } from './TimeEntryArchiveForm'; */
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import clsx from 'clsx';
import { formatDateWithDateAndMonthName, FormatInvoiceDecimalNumber, getValueFromResource } from '../../../common/timeLiveFunction';

const itemClass = 'ms-1 ms-lg-0';
const ExpenseBillingWorksheetItem = (props: any) => {
    const { onhandleFormOnClickEvent, offCanvasObject, t, onopenModal, IsEdit, IsDelete } = props;

    const dispatch = useAppDispatch();
    const { expenseBillingWorksheetList, search, optionEmployeeNameText, optionEmployeeNameValue,optionClientNameValue,optionExpenseNameText,optionExpenseNameValue,optionExpensTypeText,optionExpenseTypeValue, optionClientNameText, optionProjectValue, optionProjectText,
       optionBilledValue, startDate, endDate, start,sortOrder, sortColumn, pageSize} = useAppSelector((state) => state.expenseBillingWorksheet);
       const { decimalPlaces, cultureInfoName } = useAppSelector((state) => state.globalState);



    const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>({});

    const handleCheckboxChange = (e: any, rowId: any) => {
        const isChecked = e.target.checked;
        setCheckedItems((prev) => ({
            ...prev,
            [rowId]: isChecked,
        }));
        if (isChecked) {
            dispatch(checkedBilledState(rowId));
        } else {
            dispatch(unCheckedBilledState(rowId));
        }
    };

    const isItemChecked = (rowId: any, billed: boolean) => {
        return checkedItems[rowId] !== undefined ? checkedItems[rowId] : billed;
    };



    const onHandleSorting = (sortOrder: string, sortColumn: string) => {
        let objects = {
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "start": 0,
            "pageSize": pageSize,
            "currentPage": 1
        }
        dispatch(updateSorting(objects));
       let SearchParamsValues = `${optionClientNameValue},${optionEmployeeNameValue},${optionProjectValue},${optionExpenseNameValue},${optionExpenseTypeValue},${optionBilledValue},
                   ${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionEmployeeNameText},${optionProjectText},${optionExpenseNameText},${optionExpensTypeText}`;
        dispatch(getExpenseBilingWorksheetForDatatableAsync({ currentPage: 1, pageSize: pageSize, start: start, SearchParamsValues: SearchParamsValues, search: search }));
    }

   

    return (
        <>
          
                <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                    <thead>
                        <tr className="thHeading align-middle">
                            <th className='w-25px'> 
                               {getValueFromResource('Billed',dispatch, t)}
                                </th>
                                <th className='w-100px'>
                               {getValueFromResource('Date',dispatch, t)}
                               {sortColumn === '1' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                                </th>
                            <th className='w-100px'>
                               {getValueFromResource('Employee Name',dispatch, t)}
                               {sortColumn === '2' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                                </th>
                            <th className='w-100px'>
                               {getValueFromResource('Project Name',dispatch, t)}
                               {sortColumn === '3' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                                </th>
                            <th className='w-100px'>
                               {getValueFromResource('Expense Name (Expense Type)',dispatch, t)}
                               {sortColumn === '4' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                                </th>
                            <th className='w-100px'>
                               {getValueFromResource('Description',dispatch, t)}
                                </th>
                            <th className='w-100px'>
                               {getValueFromResource('Invoice Details',dispatch, t)}
                               {sortColumn === '5' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "5") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "5") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "5") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                                </th>
                            <th className='w-100px'>
                               {getValueFromResource('Amount',dispatch, t)}
                               {sortColumn === '6' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "6") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "6") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "6") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {expenseBillingWorksheetList.length > 0 && expenseBillingWorksheetList.map((expenseBillingObj: any, i: any) => (
                            <tr key={i}>
                               <td>
                               <div className="form-check form-switch form-check-custom">
                                    <input
                                        id="chkTimeOff"
                                        className="form-check-input h-20px w-30px"
                                        type="checkbox"
                                        checked={isItemChecked(expenseBillingObj.AccountExpenseEntryId, expenseBillingObj.Billed)}
                                        onChange={e => handleCheckboxChange(e, expenseBillingObj.AccountExpenseEntryId)}
                                    />
                                </div>
                                        {/* <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >

                                            <input
                                                type="checkbox"
                                                className="form-check-input widget-9-check"
                                                checked={isItemChecked(expenseBillingObj.AccountExpenseEntryId, expenseBillingObj.Billed)}
                                                onChange={e => handleCheckboxChange(e, expenseBillingObj.AccountExpenseEntryId)}
                                            />
                                        </div> */}
                                    </td>
                                    <td>
                                    <span style={{ color: '#7b8ba6', fontSize: 12 }} >
                                        <i className="ki-outline ki-calendar text-gray fs-5 me-2 "></i>
                                        {/* {moment.parseZone(expenseBillingObj.AccountExpenseEntryDate).format('DD MMM yy')} */}
                                        {formatDateWithDateAndMonthName(expenseBillingObj.AccountExpenseEntryDate, cultureInfoName.toString())}
                                    </span>
                                </td>
                                <td>
                                    <span className="d-block">
                                        {expenseBillingObj.EmployeeName}
                                    </span>                                   
                                </td>
                                <td>
                                    <span className="d-block">
                                        {expenseBillingObj.ProjectName}

                                    </span>
                                </td>
                                <td>
                                    <span className="d-block">
                                        {expenseBillingObj.ExpenseName != null ? expenseBillingObj.ExpenseName : 'None'}
                                    </span>
                                    <span className="d-block">
                                        {expenseBillingObj.ExpenseType != null ? expenseBillingObj.ExpenseType : 'None'}
                                    </span>
                                </td>
                                <td>
                                    <span className="d-block">
                                        {expenseBillingObj.Description != null ? expenseBillingObj.Description : 'None'}
                                    </span>
                                </td>

                                <td>
                                    <span className="d-block">
                                        <div><strong>
                                            {/* {t('Invoice No:')} */}
                                            {getValueFromResource('Invoice No:',dispatch, t)}
                                            </strong> {expenseBillingObj.InvoiceNumber}</div>
                                        <div><strong>
                                            {/* {t('Invoice Date:')} */}
                                            {getValueFromResource('Invoice Date:',dispatch, t)}
                                            </strong> 
                                            {expenseBillingObj.InvoiceDate ? formatDateWithDateAndMonthName(expenseBillingObj.InvoiceDate, cultureInfoName.toString()) : ''}</div>
                                            
                                        <div><strong>
                                            {/* {t('PO Number:')} */}
                                            {getValueFromResource('PO Number:',dispatch, t)}
                                            </strong> {expenseBillingObj.PONumber}</div>
                                    </span>
                                </td>

                                <td>
                                    <span className="d-block">
                                        {expenseBillingObj.CurrencyCode} {FormatInvoiceDecimalNumber(cultureInfoName.toString(), expenseBillingObj.Amount, decimalPlaces)}
                                    </span>
                                </td>

                            </tr>
                        ))}
                    </tbody>
                </table>
                {expenseBillingWorksheetList.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found',dispatch, t)}
                                    </p>
                            </div>
                        }
        </>
    )
}

export default ExpenseBillingWorksheetItem
